;
define("product_views_option_float.tpl", function(){});

